// Mobile hamburger menu
(function(){
  const btn=document.getElementById('mobileMenuBtn');
  const drawer=document.getElementById('mobileDrawer');
  if(!btn||!drawer)return;
  btn.addEventListener('click',()=>{
    const open=drawer.classList.toggle('open');
    btn.classList.toggle('open',open);
    document.body.style.overflow=open?'hidden':'';
  });
  drawer.querySelectorAll('a').forEach(a=>{
    a.addEventListener('click',()=>{
      drawer.classList.remove('open');
      btn.classList.remove('open');
      document.body.style.overflow='';
    });
  });
})();

// Touch drag for product grids on mobile
(function(){
  ['.prod-grid-4','.prod-grid-3','.why-grid','.review-grid','.blog-grid'].forEach(sel=>{
    const el=document.querySelector(sel);
    if(!el)return;
    let isDown=false,startX,scrollLeft;
    el.addEventListener('mousedown',e=>{isDown=true;startX=e.pageX-el.offsetLeft;scrollLeft=el.scrollLeft;el.style.cursor='grabbing'});
    window.addEventListener('mouseup',()=>{isDown=false;if(el)el.style.cursor='grab'});
    el.addEventListener('mousemove',e=>{if(!isDown)return;e.preventDefault();const x=e.pageX-el.offsetLeft;el.scrollLeft=scrollLeft-(x-startX)});
    // Touch
    let touchX;
    el.addEventListener('touchstart',e=>{touchX=e.touches[0].pageX;scrollLeft=el.scrollLeft},{passive:true});
    el.addEventListener('touchmove',e=>{if(touchX===undefined)return;const dx=touchX-e.touches[0].pageX;el.scrollLeft=scrollLeft+dx},{passive:true});
  });
})();

// FAQ accordion
document.querySelectorAll('.faq-q').forEach(q=>{
  q.addEventListener('click',()=>{
    const item=q.closest('.faq-item');
    const isOpen=item.classList.contains('open');
    document.querySelectorAll('.faq-item').forEach(i=>i.classList.remove('open'));
    if(!isOpen)item.classList.add('open');
  });
});

// Sticky nav shadow
const nav=document.getElementById('nav');
window.addEventListener('scroll',()=>{
  nav.style.boxShadow=window.scrollY>10?'0 2px 20px rgba(16,20,24,.10)':'0 1px 12px rgba(16,20,24,.06)';
});

// Collection slider — arrow buttons
function scrollColl(dir){
  const track=document.getElementById('collTrack');
  const card=track.querySelector('.col-tile');
  const w=card.offsetWidth+12;
  const current=parseInt(track.dataset.offset||0);
  const max=-(track.scrollWidth/2);
  let next=current+(dir*-w*2);
  if(next<max)next=0;
  if(next>0)next=max+w*2;
  track.dataset.offset=next;
  track.style.transition='transform .35s cubic-bezier(.25,.8,.25,1)';
  track.style.transform=`translateX(${next}px)`;
}

// Collection slider — drag to scroll
(function(){
  const slider=document.getElementById('collSlider');
  const track=document.getElementById('collTrack');
  if(!slider)return;
  let isDown=false,startX=0,scrollLeft=0;
  slider.addEventListener('mousedown',e=>{isDown=true;slider.classList.add('dragging');startX=e.pageX;scrollLeft=slider.scrollLeft});
  window.addEventListener('mouseup',()=>{isDown=false;slider.classList.remove('dragging')});
  slider.addEventListener('mousemove',e=>{if(!isDown)return;e.preventDefault();const x=e.pageX-startX;slider.scrollLeft=scrollLeft-x});
})();
// Area slider drag
(function(){
  const s=document.getElementById('areaSlider');
  if(!s)return;
  let isDown=false,startX,scrollLeft;
  s.addEventListener('mousedown',e=>{isDown=true;s.style.cursor='grabbing';startX=e.pageX-s.offsetLeft;scrollLeft=s.scrollLeft});
  window.addEventListener('mouseup',()=>{isDown=false;s.style.cursor='grab'});
  s.addEventListener('mousemove',e=>{if(!isDown)return;e.preventDefault();const x=e.pageX-s.offsetLeft;s.scrollLeft=scrollLeft-(x-startX)});
})();

// ── SCROLL REVEAL — IntersectionObserver ──
(function(){
  const OPTS={threshold:.12,rootMargin:'0px 0px -40px 0px'};
  const obs=new IntersectionObserver((entries)=>{
    entries.forEach(e=>{
      if(e.isIntersecting){
        e.target.classList.add('visible');
        // Trigger hiw-step-num pop animation
        e.target.querySelectorAll('.hiw-step-num').forEach((n,i)=>{
          setTimeout(()=>n.classList.add('popped'),i*120);
        });
        obs.unobserve(e.target);
      }
    });
  },OPTS);
  document.querySelectorAll('.reveal,.reveal-left,.reveal-right,.reveal-scale,.stagger-children,.tagline-band,.tagline-band-green').forEach(el=>obs.observe(el));
})();

// ── ANIMATED COUNTERS ──
(function(){
  function animateCount(el,target,suffix,dur){
    let start=null;
    const isFloat=target%1!==0;
    function step(ts){
      if(!start)start=ts;
      const progress=Math.min((ts-start)/dur,1);
      const ease=1-Math.pow(1-progress,3);
      const val=isFloat?(target*ease).toFixed(1):(Math.round(target*ease));
      el.textContent=val+suffix;
      if(progress<1)requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  const obs=new IntersectionObserver((entries)=>{
    entries.forEach(e=>{
      if(!e.isIntersecting)return;
      const el=e.target;
      const raw=el.dataset.count;
      const suffix=el.dataset.suffix||'';
      animateCount(el,parseFloat(raw),suffix,1400);
      obs.unobserve(el);
    });
  },{threshold:.5});
  document.querySelectorAll('[data-count]').forEach(el=>obs.observe(el));
})();

// ── NAV HIDE ON SCROLL DOWN, SHOW ON SCROLL UP ──
(function(){
  const nav=document.getElementById('nav');
  let lastY=0,ticking=false;
  window.addEventListener('scroll',()=>{
    if(!ticking){
      requestAnimationFrame(()=>{
        const y=window.scrollY;
        if(y>120){
          if(y>lastY+8)nav.style.transform='translateY(-100%)';
          else if(y<lastY-4)nav.style.transform='translateY(0)';
        }else{
          nav.style.transform='translateY(0)';
        }
        lastY=y;ticking=false;
      });
      ticking=true;
    }
  });
})();

// ── JUMPSTART CARD animate in ──
(function(){
  const card=document.querySelector('.js-card');
  if(!card)return;
  const obs=new IntersectionObserver((entries)=>{
    if(entries[0].isIntersecting){card.classList.add('visible-anim');obs.unobserve(card);}
  },{threshold:.3});
  obs.observe(card);
})();

// Make collection slider overflow scrollable instead of transform
(function(){
  const slider=document.getElementById('collSlider');
  const track=document.getElementById('collTrack');
  if(!slider||!track)return;
  slider.style.overflowX='auto';
  slider.style.scrollBehavior='smooth';
  slider.style.scrollbarWidth='none';
  slider.style.msOverflowStyle='none';
  track.style.width='max-content';
  track.style.transform='none';
})();
function scrollColl(dir){
  const slider=document.getElementById('collSlider');
  slider.scrollBy({left:dir*420,behavior:'smooth'});
}
